import React from "react";
import "./Footer.scss";
import logo from "../../../assets/footer.svg";
import fb from "../../../assets/iconz/Vector (15).png";
import twitter from "../../../assets/iconz/Vector (16).png";
import mail from "../../../assets/iconz/clarity_email-solid.png";
const Footer = () => (
  <div>
    <div className="subscribe">
      <h5>Subscribe To Our Newsletter</h5>
      <form action="">
        <input type="email" placeholder="youremail@address.com" />
        <button type="">Subscribe</button>
      </form>
    </div>
    <div className="footer">
      <div className="footer-top">
        <img className="logo" src={logo} alt="logo" />
        <div className="footer-links">
          <h5>GETTING STARTED</h5>
          <p>Pricing</p>
          <p>About Us</p>
        </div>
        <div className="footer-links">
          <h5>CONNECT WITH US</h5>
          <div className="social d-flex justify-content-between">
            <img src={fb} alt="" />
            <img src={twitter} alt="" />
            <img src={mail} alt="" />
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="footer-bottom-1">
          Learnerkia - For Learning and Development ©2021{" "}
        </p>
        <div className="second d-flex flex-column flex-lg-row justify-content-between">
          <p className="footer-bottom-1">Terms</p>
          <p className="footer-bottom-1">Privacy</p>
        </div>
      </div>
    </div>
  </div>
);

export default Footer;
